﻿<div class="dropdown" [ngClass]="settings.containerClasses" [class.open]="isVisible">
  <button type="button" [ngClass]="settings.buttonClasses"
    (click)="toggleDropdown()" [disabled]="disabled">
    <div class="truncate btn-label">{{ title | translate}}</div>
    <span class="btn-caret caret"></span>
  </button>
  @if (isVisible) {
    <ul (mouseleave)="onMouseLeave($event)" class="dropdown-menu" [class.pull-right]="settings.pullRight" [class.dropdown-menu-right]="settings.pullRight"
      [style.max-height]="settings.maxHeight" style="display: block; height: auto; overflow-y: auto;"
      infinite-scroll
      [infiniteScrollThrottle]="500"
      (scrolled)="getPaginatedOptions()"
      [scrollWindow]="false">
      @if (settings.enableSearch) {
        <li class="dropdown-item search">
          <div class="input-group input-group-sm">
            <div class="input-group-addon dropdown-search-icon-container" id="sizing-addon3"><i class="fa fa-search"></i></div>
            <input type="text" class="form-control" placeholder="{{ texts.searchPlaceholder | translate}}" aria-describedby="sizing-addon3" [(ngModel)]="searchFilterText"
              [ngModelOptions]="{standalone: true}" autofocus
              [ngModel]="searchFilterText" (ngModelChange)="searchFilterTextChange($event)">
            @if (searchFilterText.length > 0) {
              <span class="input-group-btn">
                <button class="btn btn-secondary btn-secondary" type="button" (click)="clearSearch($event)"><i class="fa fa-times"></i></button>
              </span>
            }
          </div>
        </li>
      }
      @if (settings.enableSearch) {
        <li class="dropdown-divider divider"></li>
      }
      @if (settings.showCheckAll) {
        <li class="dropdown-item check-control check-control-check">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="checkAll()">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-ok': settings.checkedStyle !== 'fontawesome','fa fa-check': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.checkAll | translate }}
          </a>
        </li>
      }
      @if (settings.showUncheckAll) {
        <li class="dropdown-item check-control check-control-uncheck">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="uncheckAll() && emitUncheckedMonths()">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-remove': settings.checkedStyle !== 'fontawesome','fa fa-times': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.uncheckAll | translate }}
          </a>
        </li>
      }
      @if (texts.yearToDate) {
        <li class="dropdown-item check-control check-control-check">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="checkMonths('year_to_date')">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-ok': settings.checkedStyle !== 'fontawesome','fa fa-check': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.yearToDate | translate }}
          </a>
        </li>
      }
      @if (texts.latestMonth) {
        <li class="dropdown-item check-control check-control-check">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="checkMonths('latest_month', 1)">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-ok': settings.checkedStyle !== 'fontawesome','fa fa-check': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.latestMonth | translate }}
          </a>
        </li>
      }
      @if (texts.latestFullMonth) {
        <li class="dropdown-item check-control check-control-check">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="checkMonths('latest_full_month', 1, 1)">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-ok': settings.checkedStyle !== 'fontawesome','fa fa-check': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.latestFullMonth | translate }}
          </a>
        </li>
      }
      @if (texts.latest3FullMonths) {
        <li class="dropdown-item check-control check-control-check">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="checkMonths('latest_3_full_months', 3)">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-ok': settings.checkedStyle !== 'fontawesome','fa fa-check': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.latest3FullMonths | translate }}
          </a>
        </li>
      }
      @if (texts.latest6FullMonths) {
        <li class="dropdown-item check-control check-control-check">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="checkMonths('latest_6_full_months', 6)">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-ok': settings.checkedStyle !== 'fontawesome','fa fa-check': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.latest6FullMonths | translate }}
          </a>
        </li>
      }
      @if (texts.latest9FullMonths) {
        <li class="dropdown-item check-control check-control-check">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="checkMonths('latest_9_full_months', 9)">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-ok': settings.checkedStyle !== 'fontawesome','fa fa-check': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.latest9FullMonths | translate }}
          </a>
        </li>
      }
      @if (texts.latest12FullMonths) {
        <li class="dropdown-item check-control check-control-check">
          <a href="javascript:;" role="menuitem" tabindex="-1" (click)="checkMonths('latest_12_full_months', 12)">
            <span style="width: 16px;" [ngClass]="{'glyphicon glyphicon-ok': settings.checkedStyle !== 'fontawesome','fa fa-check': settings.checkedStyle === 'fontawesome'}"></span>
            {{ texts.latest12FullMonths | translate }}
          </a>
        </li>
      }
      @if (settings.showCheckAll || settings.showUncheckAll) {
        <li class="dropdown-divider divider"></li>
      }
      @for (option of scrollableOptions | searchFilter:searchFilterText; track option) {
        <li class="dropdown-item" [ngStyle]="getItemStyle(option)"
          (click)="!option.isLabel && setSelected($event, option)" [class.dropdown-header]="option.isLabel">
          @if (option.isLabel) {
            {{ option.name  | translate}}
          }
          @if (!option.isLabel) {
            <a href="javascript:;" role="menuitem" tabindex="-1" [style.padding-left]="this.parents.length>0&&this.parents.indexOf(option.id)<0&&'30px'">
              @if (settings.checkedStyle === 'checkboxes') {
                <input type="checkbox" [checked]="isSelected(option)" (click)="preventCheckboxCheck($event, option)"/>
              }
              @if (settings.checkedStyle === 'glyphicon') {
                <span style="width: 16px;" class="glyphicon" [class.glyphicon-ok]="isSelected(option)"></span>
              }
              @if (settings.checkedStyle === 'fontawesome') {
                <span style="width: 16px;display: inline-block;">
                  @if (isSelected(option)) {
                    <i class="fa fa-check" aria-hidden="true"></i>
                  }
                </span>
              }
              <span [ngClass]="settings.itemClasses" [style.font-weight]="this.parents.indexOf(option.id)>=0?'bold':'normal'">
                {{ option.name | translate}}
              </span>
            </a>
          }
        </li>
      }
    </ul>
  }
</div>
